import { render, staticRenderFns } from "./LessonOrdering.vue?vue&type=template&id=5ff78276&scoped=true&"
import script from "./LessonOrdering.vue?vue&type=script&lang=js&"
export * from "./LessonOrdering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff78276",
  null
  
)

export default component.exports